import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminInquiries.ingredientsSearch;
export const adminIngredientsSearchSelector = (state: RootState) =>
  getState(state).data?.tableData || [];
export const adminIngredientsSearchPaginationSelector = (state: RootState) =>
  getState(state).data?.pagination;
export const adminIngredientsSearchIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const adminAddIngredientsModalOpen = (state: RootState) =>
  getState(state).addIngredientModalOpen;
export const adminCreateIngredientPending = (state: RootState) =>
  getState(state).isCreateIngredientPending;
export const adminSearchStringForAddIngredientModal = (state: RootState) =>
  getState(state).searchStringForAddIngredientModal;
